import axios from 'axios';

const base_url = process.env.REACT_APP_API_URL;

class FormApi {

    static getBaseUrl(){
        return base_url;
    }
    
    static getCities() {
        return axios.get(base_url + 'api/cities');
    }

    static getUniversities(city) {
        return axios.get(base_url + 'api/universities/' + city)
    }

    static getFaculties(university){
        return axios.get(base_url + 'api/faculties/'+university)
    }

    static getSection(university) {
        return axios.get(base_url + 'api/section/' + university)
    }

    static getCountries(){
        return axios.get(base_url + 'api/countries');
    }

    static getSemesters(){
        return axios.get(base_url + 'api/semesters/active');
    }

    static saveStudent(student) {
        return axios.post(base_url + 'api/student', student);
    }
}

export default FormApi;
